export default "__VITE_ASSET__Bhz04gz5__"